import { preprocess } from "svelte/compiler";
const preprocessChain = (preprocessors) => {
    return {
        markup: async ({ content, filename }) => preprocessors.reduce(async (previousResult, preprocessor) => {
            const { code } = await previousResult;
            return preprocess(code || content, preprocessor, {
                filename,
            });
        }, Promise.resolve({
            code: "",
        })),
    };
};
module.exports = preprocessChain;
export default preprocessChain;
